<script>
  const genreSeeds = [
    "pop",
    "hip-hop/rap",
    "alternative",
    "rap",
    "rock",
    "hip hop",
    "canadian pop",
    "dance pop",
    "modern rock",
    "pop rap",
    "pov: indie",
    "r&b",
    "art pop",
    "permanent wave",
    "canadian contemporary r&b",
    "dance",
    "trap",
    "atl hip hop",
    "edm",
    "uk pop",
    "melodic rap",
    "pop dance",
    "indietronica",
    "urban contemporary",
    "chicago rap",
    "canadian hip hop",
    "slap house",
    "southern hip hop",
    "electronic",
    "alt z",
    "r&b/soul",
    "conscious hip hop",
    "metropopolis",
    "modern alternative rock",
    "electro house",
    "west coast rap",
    "singer-songwriter pop",
    "bedroom pop",
    "indie pop",
    "neo soul",
    "electropop",
    "gangster rap",
    "miami hip hop",
    "house",
    "east coast hip hop",
    "lgbtq+ hip hop",
    "viral pop",
    "uk dance",
    "alternative rock",
    "queens hip hop",
    "alternative r&b",
    "hip pop",
    "detroit hip hop",
    "barbadian pop",
    "classic rock",
    "indie rock",
    "post-teen pop",
    "soundtrack",
    "alternative metal",
    "rage rap",
    "indie poptimism",
    "progressive house",
    "trap latino",
    "soft rock",
    "australian pop",
    "singer/songwriter",
    "hard rock",
    "brostep",
    "garage rock",
    "piano rock",
    "progressive electro house",
    "escape room",
    "colombian pop",
    "australian dance",
    "dfw rap",
    "album rock",
    "underground hip hop",
    "talent show",
    "pluggnb",
    "swedish pop",
    "boy band",
    "mellow gold",
    "pop rock",
    "urbano latino",
    "trap queen",
    "post-grunge",
    "singer-songwriter",
    "new wave pop",
    "big room",
    "pittsburgh rap",
    "neo-synthpop",
    "soul",
    "alternative hip hop",
    "north carolina hip hop",
    "pop soul",
    "modern indie pop",
    "afrofuturism",
    "british soul",
    "melancholia",
    "reggaeton",
    "dream pop",
    "nu metal",
    "new orleans rap",
    "emo rap",
    "neo mellow",
    "indie soul",
    "plugg",
    "dirty south rap",
    "k-pop",
    "pop punk",
    "trap soul",
    "europop",
    "la indie",
    "sheffield indie",
    "chamber pop",
    "philly rap",
    "candy pop",
    "dance rock",
    "country",
    "ohio hip hop",
    "filter house",
    "gen z singer-songwriter",
    "new wave",
    "rap metal",
    "uk contemporary r&b",
    "electro",
    "art rock",
    "glam rock",
    "metal",
    "brooklyn indie",
    "cloud rap",
    "shoegaze",
    "atl trap",
    "uk hip hop",
    "jazz",
    "contemporary r&b",
    "etherpop",
    "la pop",
    "neo-psychedelic",
    "sped up",
    "indie folk",
    "new romantic",
    "latin pop",
    "kentucky hip hop",
    "pop r&b",
    "stomp and holler",
    "swedish electropop",
    "electronica",
    "canadian trap",
    "australian psych",
    "hyperpop",
    "downtempo",
    "uk alternative pop",
    "complextro",
    "g funk",
    "contemporary country",
    "dutch edm",
    "drill",
    "baroque pop",
    "tropical house",
    "dark trap",
    "emo",
    "punk",
    "deep underground hip hop",
    "ambient pop",
    "heartland rock",
    "alternative dance",
    "nz pop",
    "adult standards",
    "afrobeats",
    "hardcore hip hop",
    "indie pop rap",
    "cali rap",
    "synthpop",
    "dutch house",
    "memphis hip hop",
    "trance",
    "australian hip hop",
    "folk-pop",
    "el paso indie",
    "moombahton",
    "pixie",
    "lo-fi indie",
    "yacht rock",
    "melodic drill",
    "madchester",
    "oxford indie",
    "grunge",
    "lilith",
    "psychedelic rock",
    "pop edm",
    "indie anthem-folk",
    "german techno",
    "nigerian pop",
    "pop emo",
    "k-pop girl group",
    "electronic trap",
    "chicago drill",
    "dancehall",
    "modern alternative pop",
    "instrumental hip hop",
    "funk metal",
    "lounge",
    "irish rock",
    "scandipop",
    "funk",
    "uk post-punk",
    "folk",
    "new rave",
    "experimental pop",
    "australian electropop",
    "girl group",
    "grime",
    "new jersey rap",
    "alternative pop rock",
    "virginia hip hop",
    "irish singer-songwriter",
    "reggaeton colombiano",
    "eurodance",
    "florida rap",
    "vocal jazz",
    "dark r&b",
    "sophisti-pop",
    "bubblegrunge",
    "disco",
    "pixel",
    "edmonton indie",
    "indie hip hop",
    "houston rap",
    "dreamo",
    "old school atlanta hip hop",
    "shimmer pop",
    "orchestral soundtrack",
    "modern dream pop",
    "gauze pop",
    "uk funky",
    "funk rock",
    "italian pop",
    "j-pop",
    "british invasion",
    "k-pop boy group",
    "neon pop punk",
    "glam metal",
    "classical",
    "easy listening",
    "german dance",
    "chicago bop",
    "noise pop",
    "social media pop",
    "trip hop",
    "psychedelic hip hop",
    "stutter house",
    "puerto rican pop",
    "brooklyn drill",
    "eau claire indie",
    "nyc rap",
    "french pop",
    "crunk",
    "rap rock",
    "bedroom r&b",
    "norwegian indie",
    "pop latino",
    "britpop",
    "country dawn",
    "german pop",
    "anime",
    "meme rap",
    "norwegian pop",
    "experimental hip hop",
    "glitchcore",
    "pop nacional",
    "folk rock",
    "australian indie",
    "r&drill",
    "indie r&b",
    "comedy",
    "south carolina hip hop",
    "chill pop",
    "latin",
    "florida drill",
    "swedish synthpop",
    "deep house",
    "sacramento indie",
    "countrygaze",
    "tennessee hip hop",
    "progressive rock",
    "metalcore",
    "country road",
    "reggae",
    "viral rap",
    "aesthetic rap",
    "hollywood",
    "video game music",
    "punk blues",
    "bronx drill",
    "latin hip hop",
    "movie tunes",
    "canadian rock",
    "experimental r&b",
    "hypertechno",
    "indie surf",
    "belgian edm",
    "oakland hip hop",
    "worldwide",
    "speedrun",
    "symphonic rock",
    "otacore",
    "nyc pop",
    "r&b en espanol",
    "reggae fusion",
    "shiver pop",
    "electra",
    "melodic metalcore",
    "merseybeat",
    "weirdcore",
    "drama",
    "small room",
    "afropop",
    "drumless hip hop",
    "philly indie",
    "proto-hyperpop",
    "nigerian hip hop",
    "transpop",
    "blues rock",
    "dance-punk",
    "quiet storm",
    "dark pop",
    "classic texas country",
    "sad rap",
    "aussietronica",
    "bedroom soul",
    "classic soul",
    "show tunes",
    "chillwave",
    "ambient folk",
    "rap latina",
    "teen pop",
    "uk metalcore",
    "vapor twitch",
    "psychedelic pop",
    "indie rock italiano",
    "motown",
    "baltimore indie",
    "canadian electronic",
    "deep euro house",
    "slowcore",
    "pop house",
    "beatlesque",
    "melodic dubstep",
    "socal pop punk",
    "trap argentino",
    "modern folk rock",
    "música mexicana",
    "acoustic pop",
    "canadian electropop",
    "classic oklahoma country",
    "modern blues rock",
    "sad lo-fi",
    "irish pop",
    "political hip hop",
    "sad sierreno",
    "german hip hop",
    "canadian latin",
    "jazz pop",
    "latin alternative",
    "british singer-songwriter",
    "vapor soul",
    "ambient",
    "belgian pop",
    "country rock",
    "latin viral pop",
    "mexican pop",
    "nu disco",
    "seattle hip hop",
    "french synthpop",
    "modern power pop",
    "corridos tumbados",
    "christian",
    "instrumental grime",
    "french hip hop",
    "hip-hop",
    "screamo",
    "argentine hip hop",
    "broadway",
    "canadian indie rock",
    "outlaw country",
    "compositional ambient",
    "industrial metal",
    "k-rap",
    "british indie rock",
    "baton rouge rap",
    "rock-and-roll",
    "australian rock",
    "industrial rock",
    "grave wave",
    "dark clubbing",
    "urbano espanol",
    "dutch pop",
    "minnesota hip hop",
    "afro r&b",
    "vancouver indie",
    "sigilkore",
    "hyper-rock",
    "azonto",
    "modern country rock",
    "p funk",
    "rockabilly",
    "pop venezolano",
    "old school thrash",
    "melbourne bounce international",
    "danish pop",
    "melbourne bounce",
    "thrash metal",
    "pop reggaeton",
    "new age",
    "future bass",
    "boston folk",
    "pop urbaine",
    "korean r&b",
    "tech house",
    "birmingham grime",
    "golden age hip hop",
    "atlanta indie",
    "uk alternative hip hop",
    "orchestra",
    "future house",
    "chicago indie",
    "chill abstract hip hop",
    "intelligent dance music",
    "spanish pop",
    "azontobeats",
    "rap conscient",
    "stomp pop",
    "swedish indie pop",
    "dutch trance",
    "hip house",
    "dubstep",
    "drift phonk",
    "modern indie folk",
    "new americana",
    "dancefloor dnb",
    "christian alternative rock",
    "indie garage rock",
    "reggaeton flow",
    "canadian indie",
    "spacegrunge",
    "hypnagogic pop",
    "rock en espanol",
    "new jersey indie",
    "scenecore",
    "alternative emo",
    "french indie pop",
    "modern country pop",
    "techno",
    "swing",
    "french shoegaze",
    "latin rock",
    "r&b francais",
    "abstract hip hop",
    "nintendocore",
    "post-punk",
    "italian adult pop",
    "gaming edm",
    "bass house",
    "new jack swing",
    "disco house",
    "drum and bass",
    "celtic rock",
    "comic",
    "meme",
    "trap boricua",
    "industrial",
    "chill r&b",
    "indie electropop",
    "newcastle nsw indie",
    "ambient lo-fi",
    "instrumental",
    "bitpop",
    "southern soul",
    "liverpool indie",
    "mississippi hip hop",
    "boom bap",
    "folktronica",
    "vocal house",
    "boston rock",
    "digital hardcore",
    "phonk",
    "birmingham metal",
    "roots reggae",
    "christian music",
    "future garage",
    "funk rj",
    "german soundtrack",
    "portland hip hop",
    "classic country pop",
    "jazz rap",
    "seattle indie",
    "southern rock",
    "upstate ny rap",
    "corrido",
    "trap triste",
    "alte",
    "bass trap",
    "deep groove house",
    "old school hip hop",
    "scottish rock",
    "london rap",
    "sierreno",
    "british orchestra",
    "electropowerpop",
    "english indie rock",
    "nu gaze",
    "canadian metal",
    "j-rock",
    "new jersey underground rap",
    "brighton indie",
    "german metal",
    "latin arena pop",
    "lo-fi emo",
    "jazz funk",
    "funk pop",
    "musica mexicana",
    "japanese teen pop",
    "melodic house",
    "stoner rock",
    "buffalo hip hop",
    "lo-fi beats",
    "indie quebecois",
    "lo-fi chill",
    "funk carioca",
    "toronto indie",
    "canadian singer-songwriter",
    "classical performance",
    "rock y alternativo",
    "romanian pop",
    "rap canario",
    "sky room",
    "pop argentino",
    "industrial hip hop",
    "neo-classical",
    "jazz blues",
    "pink noise",
    "hopebeat",
    "chillhop",
    "musicals",
    "turntablism",
    "filthstep",
    "g-house",
    "anime rock",
    "deconstructed club",
    "ectofolk",
    "japanese soundtrack",
    "new french touch",
    "new york drill",
    "northern irish indie",
    "australian house",
    "traprun",
    "sunshine pop",
    "gym phonk",
    "power pop",
    "vapor pop",
    "big beat",
    "crank wave",
    "roots rock",
    "vegas indie",
    "protopunk",
    "slowed and reverb",
    "soul blues",
    "bossbeat",
    "zolo",
    "scam rap",
    "bassline",
    "black americana",
    "italian hip hop",
    "pagode baiano",
    "bubblegum bass",
    "lustrum",
    "bubblegum dance",
    "detroit trap",
    "german rock",
    "oakland indie",
    "neo-singer-songwriter",
    "post-hardcore",
    "country pop",
    "german cloud rap",
    "jungle/drum'n'bass",
    "reading indie",
    "deep talent show",
    "trancecore",
    "rap dominicano",
    "blues",
    "dark synthpop",
    "christian rock",
    "wonky",
    "ccm",
    "hardcore",
    "experimental",
    "stomp and flutter",
    "anime score",
    "spanish hip hop",
    "diva house",
    "tropical",
    "boston hip hop",
    "breakbeat",
    "dembow",
    "italo dance",
    "lo-fi",
    "mandopop",
    "nashville indie",
    "british soundtrack",
    "electronic rock",
    "hardwave",
    "icelandic pop",
    "manchester hip hop",
    "opm",
    "trap italiana",
    "bachata",
    "chill drill",
    "japanese vgm",
    "boston indie",
    "ethereal wave",
    "korean city pop",
    "scottish indie",
    "skate punk",
    "slc indie",
    "bergen indie",
    "american metalcore",
    "groove metal",
    "jazz trumpet",
    "korean ost",
    "south african pop",
    "battle rap",
    "gym hardstyle",
    "vaporwave",
    "acid rock",
    "chanson",
    "japanese electropop",
    "música tropical",
    "neue deutsche harte",
    "rap francais",
    "jazz boom bap",
    "memphis soul",
    "austindie",
    "welsh rock",
    "afroswing",
    "canadian punk",
    "j-pixie",
    "nu-metalcore",
    "polish pop",
    "funktronica",
    "alternative folk",
    "australian alternative pop",
    "covertronica",
    "german drill",
    "asian american hip hop",
    "mpb",
    "children's music",
    "new orleans jazz",
    "viral trap",
    "detroit rock",
    "ghanaian pop",
    "indie game soundtrack",
    "spanish rock",
    "alabama rap",
    "swamp rock",
    "bossa nova",
    "post-disco",
    "torch song",
    "drill espanol",
    "uk drill",
    "hawaiian hip hop",
    "uk doom metal",
    "art punk",
    "indiana hip hop",
    "ranchera",
    "classic canadian rock",
    "dutch hip hop",
    "euphoric hardstyle",
    "nu jazz",
    "fidget house",
    "japanese chillhop",
    "phonk brasileiro",
    "world",
    "riot grrrl",
    "rock drums",
    "canadian pop punk",
    "grungegaze",
    "spectra",
    "bc underground hip hop",
    "modern hard rock",
    "german alternative rap",
    "icelandic experimental",
    "speed metal",
    "brill building pop",
    "cantautora mexicana",
    "nordic house",
    "hi-nrg",
    "nightcore",
    "russian edm",
    "belgian dance",
    "ghanaian alternative",
    "nashville singer-songwriter",
    "russian pop",
    "harlem hip hop",
    "classic hardstyle",
    "emoplugg",
    "sudanese pop",
    "vocal",
    "brazilian",
    "diy emo",
    "australian surf rock",
    "j-metal",
    "polish hip hop",
    "epicore",
    "urbano mexicano",
    "fluxwork",
    "french indietronica",
    "mexican rock",
    "wave",
    "westcoast flow",
    "dancehall queen",
    "uk experimental electronic",
    "drone",
    "hamburg hip hop",
    "belgian hip hop",
    "electro latino",
    "korean pop",
    "late romantic era",
    "nouvelle chanson francaise",
    "american shoegaze",
    "glitch hop",
    "orchestral performance",
    "post-romantic era",
    "tekk",
    "bubblegum pop",
    "chillstep",
    "deep tropical house",
    "sudanese hip hop",
    "french rock",
    "instrumental rock",
    "christian indie",
    "gaming dubstep",
    "icelandic singer-songwriter",
    "synth funk",
    "latinx alternative",
    "scorecore",
    "experimental vocal",
    "float house",
    "hardcore techno",
    "rebel blues",
    "soul jazz",
    "swedish alternative rock",
    "ambient worship",
    "australian indie folk",
    "cyberpunk",
    "deep pop edm",
    "lo-fi rap",
    "variete francaise",
    "scream rap",
    "uk americana",
    "australian reggae fusion",
    "chill phonk",
    "noise rock",
    "romanian house",
    "brisbane indie",
    "danish electronic",
    "indian edm",
    "north east england indie",
    "happy hardcore",
    "progressive trance",
    "filmi",
    "hardcore punk",
    "nordic soundtrack",
    "solo wave",
    "chill breakcore",
    "j-division",
    "rap conciencia",
    "rochester mn indie",
    "bebop",
    "cool jazz",
    "idol rock",
    "neo r&b",
    "power metal",
    "ukg revival",
    "alabama indie",
    "northern soul",
    "scottish singer-songwriter",
    "surf punk",
    "experimental folk",
    "panamanian pop",
    "st louis rap",
    "baile funk",
    "argentine rock",
    "chill dream pop",
    "holiday",
    "springfield mo indie",
    "women's music",
    "brazilian edm",
    "dutch rock",
    "japanese alternative pop",
    "polish viral pop",
    "prog metal",
    "progressive metalcore",
    "minimal techno",
    "a cappella",
    "chill house",
    "polish trap",
    "traphall",
    "classic city pop",
    "early romantic era",
    "gothic metal",
    "swedish tropical house",
    "neoperreo",
    "modern bollywood",
    "braindance",
    "drain",
    "techno remix",
    "furry",
    "operatic pop",
    "uplifting trance",
    "minneapolis sound",
    "electro-pop francais",
    "electroclash",
    "urbano chileno",
    "jazz saxophone",
    "pop folk",
    "vocaloid",
    "garage rock revival",
    "kawaii metal",
    "norteno",
    "ottawa rap",
    "stoner metal",
    "rap marseille",
    "basshall",
    "ai",
    "fourth world",
    "glitch",
    "harlem renaissance",
    "rhode island rap",
    "drill francais",
    "uk dancehall",
    "glitchbreak",
    "washington indie",
    "cloud rap francais",
    "german trap",
    "minimalism",
    "r&b argentino",
    "supergroup",
    "trap catala",
    "anti-folk",
    "classic uk pop",
    "dutch rap pop",
    "japanese classical",
    "progressive metal",
    "charva",
    "classic italian pop",
    "game mood",
    "indie punk",
    "electric blues",
    "frauenrap",
    "rap belge",
    "antiviral pop",
    "rap napoletano",
    "spanish pop rock",
    "jersey club",
    "nashville sound",
    "pop electronico",
    "witch house",
    "trap chileno",
    "uk dnb",
    "alternative rap",
    "desi hip hop",
    "k-indie",
    "visual kei",
    "asbury park indie",
    "hamburg electronic",
    "ska",
    "australian country",
    "bollywood",
    "bow pop",
    "classical era",
    "finnish pop",
    "hardvapour",
    "south african pop dance",
    "texas pop punk",
    "deep new americana",
    "alternative country",
    "cantautor",
    "milan indie",
    "rawstyle",
    "classical piano",
    "dutch indie",
    "indonesian hip hop",
    "jamaican dancehall",
    "nwobhm",
    "proto-metal",
    "rap catala",
    "rhythm game",
    "british blues",
    "canadian country",
    "classical crossover",
    "latin talent show",
    "mexican indie",
    "russian hip hop",
    "indonesian r&b",
    "electrofox",
    "icelandic indie",
    "jazztronica",
    "bolero",
    "doomgaze",
    "old school bassline",
    "uk garage",
    "brazilian jazz",
    "classic soundtrack",
    "impressionism",
    "palm desert scene",
    "arkansas country",
    "british alternative rock",
    "funk mtg",
    "lo-fi house",
    "venezuelan hip hop",
    "athens indie",
    "auckland indie",
    "deep german hip hop",
    "grimewave",
    "swedish idol pop",
    "anime lo-fi",
    "comedy rap",
    "icelandic rock",
    "pop violin",
    "world worship",
    "japanese singer-songwriter",
    "post-rock",
    "worship",
    "quebec indie",
    "scandinavian r&b",
    "violin",
    "experimental ambient",
    "salsa",
    "ska punk",
    "austrian pop",
    "chamber orchestra",
    "chopped and screwed",
    "jacksonville indie",
    "samba",
    "souldies",
    "jazz piano",
    "ann arbor indie",
    "classic girl group",
    "indie rockism",
    "lo-fi study",
    "mariachi",
    "psychedelic soul",
    "south african house",
    "experimental rock",
    "folk punk",
    "hyphy",
    "dark plugg",
    "gospel",
    "japanese old school hip hop",
    "scottish electronic",
    "banda",
    "jazz fusion",
    "korean indie rock",
    "midwest emo",
    "chinese idol pop",
    "indiecoustica",
    "russian romanticism",
    "sertanejo universitario",
    "anthem emo",
    "early music",
    "blackgaze",
    "contemporary post-bop",
    "irish hip hop",
    "kawaii future bass",
    "trap dominicano",
    "baroque",
    "german romanticism",
    "bases de freestyle",
    "dream plugg",
    "jazz guitar",
    "argentine indie",
    "hyperpop francais",
    "mexican hip hop",
    "rap genovese",
    "rap kreyol",
    "strut",
    "swedish metal",
    "symphonic metal",
    "mashup",
    "south african alternative",
    "comic metal",
    "rome indie",
    "ska mexicano",
    "swedish soul",
    "chinese electropop",
  ];

  // Import your list components
  import TrackList from "./TrackList.svelte";
  import ArtistList from "./ArtistList.svelte";
  import AlbumList from "./AlbumList.svelte";
  import GenreList from "./GenreList.svelte";

  import { onMount } from "svelte";
  import Doughnut from "./Doughnut.svelte";

  let loading = false;
  let lastResponse; // Assume this holds the last fetched data

  let uniqueUserCount = 0;
  let topArtists = [];
  let topTracks = [];
  let topAlbums = [];
  let topGenres = [];
  let countryData = {
    labels: [],
    datasets: [{ data: [] }],
  };
  let decisionData = {
    labels: [],
    datasets: [{ data: [] }],
  };
  let subscriptionData = {
    labels: [],
    datasets: [{ data: [] }],
  };
  let plusData = {
    labels: [],
    datasets: [{ data: [] }],
  };
  let deviceData = {
    labels: [],
    datasets: [{ data: [] }],
  };
  let decisionMsData = {};
  let streamedMinutesByArtistData = {}; // To store stats and percentiles for same artist
  let totalStreamedMinutesData = {}; // To store stats and percentiles for total streamed minutes

  let filters = {
    decision: [],
    timeRange: "LIFETIME",
    plus: [],
    platform: [],
    country: [],
    product: [],
    genre: "All Genres",
    limit: 100,
    top: {
      only: false,
      hideVotes: false,
    },
  };

  function convertToPercentage(value, total = 17316) {
    return ((value / total) * 100).toFixed(2);
  }

  function handleCheckboxChange(event, filterKey) {
    const { checked, value } = event.target;
    if (checked) {
      // Add the value to the appropriate filter array
      filters[filterKey] = [...filters[filterKey], value];
    } else {
      // Remove the value from the appropriate filter array
      filters[filterKey] = filters[filterKey].filter((item) => item !== value);
    }

    filters[filterKey] = [...new Set(filters[filterKey])]; // Remove duplicates

    fetchData(); // Re-fetch the data with the updated filters
  }

  // Function to handle when a genre is selected
  function handleGenreChange(event) {
    filters.genre = event.target.value;
    // Assuming you have a fetchData function that re-fetches the data based on the selected filters
    fetchData();
  }

  function handleTimeRangeChange(event) {
    filters.timeRange = event.target.value;
    fetchData();
  }

  function getQuery() {
    const query = {
      bool: {
        must: [],
      },
    };

    if (filters.decision.length > 0) {
      query.bool.must.push({
        terms: {
          decision: filters.decision,
        },
      });
    }

    if (filters.plus.length > 0) {
      query.bool.must.push({
        terms: {
          "user.plus": filters.plus,
        },
      });
    }

    if (filters.product.length > 0) {
      query.bool.must.push({
        terms: {
          "user.product": filters.product,
        },
      });
    }

    if (filters.platform.length > 0) {
      query.bool.must.push({
        terms: {
          device: filters.platform,
        },
      });
    }

    if (filters.genre !== "All Genres") {
      query.bool.must.push({
        term: {
          [`user.top.${filters.timeRange}.genres`]: filters.genre,
        },
      });
    }

    return query;
  }

  async function fetchData(limit = 100) {
    if (loading === true) return;

    loading = true;

    filters.limit = +limit;

    const query = {
      size: 0,
      query: getQuery(),
      track_total_hits: true,
      aggs: {
        spotify_subscription: {
          terms: {
            field: "user.product",
          },
        },
        plus: {
          terms: {
            field: "user.plus",
          },
        },
        decision: {
          terms: {
            field: "decision",
          },
        },
        device: {
          terms: {
            field: "device",
          },
        },
        country: {
          terms: {
            field: "user.country",
            size: 1000,
          },
        },
        decisionMs: {
          extended_stats: {
            field: "decisionMs",
          },
        },
        decisionMsPercentiles: {
          percentiles: {
            field: "decisionMs",
          },
        },
        unique_users: {
          cardinality: {
            field: "user.id",
          },
        },
        ...(() => ({
          //   [`top_tracks_${filters.timeRange}`]: {
          top_tracks: {
            terms: {
              //   field: "user.top.WEEKS.trackIds",
              field: `user.top.${filters.timeRange}.trackIds`,
              size: filters.limit,
            },
          },
          //   [`top_artists_${filters.timeRange}`]: {
          top_artists: {
            terms: {
              //   field: "user.top.WEEKS.artistIds",
              field: `user.top.${filters.timeRange}.artistIds`,
              size: filters.limit,
            },
          },
          //   [`top_albums_${filters.timeRange}`]: {
          top_albums: {
            terms: {
              //   field: "user.top.WEEKS.albumIds",
              field: `user.top.${filters.timeRange}.albumIds`,
              size: filters.limit,
            },
          },
          //   [`top_genres_${filters.timeRange}`]: {
          top_genres: {
            terms: {
              //   field: "user.top.WEEKS.genres",
              field: `user.top.${filters.timeRange}.genres`,
              size: filters.limit,
            },
          },
          streamedMinutesByArtist: {
            filter: { term: { "user.plus": true } },
            aggs: {
              stats: {
                stats: {
                  field: `user.statsFromSameArtist.${filters.timeRange}.playedMs`,
                },
              },
              percentiles: {
                percentiles: {
                  field: `statsFromSameArtist.${filters.timeRange}.playedMs`,
                },
              },
            },
          },
          totalStreamedMinutes: {
            filter: { term: { "user.plus": true } },
            aggs: {
              stats: {
                stats: { field: `user.stats.${filters.timeRange}.playedMs` },
              },
              percentiles: {
                percentiles: { field: `stats.${filters.timeRange}.playedMs` },
              },
            },
          },
        }))(),
      },
    };
    // Assume `fetchDataFromElasticsearch` is a function you've defined to interact with Elasticsearch
    const result = await fetchDataFromElasticsearch(query);
    lastResponse = result;
    topArtists = result.top_artists.buckets; // Adjust based on actual response structure
    topTracks = result.top_tracks.buckets;
    topAlbums = result.top_albums.buckets;
    topGenres = result.top_genres.buckets;
    uniqueUserCount = result.unique_users.value;

    // Fetch and process top tracks, artists, and albums simultaneously
    const [trackIds, artistIds, albumIds] = [
      topTracks.map((track) => track.key),
      topArtists.map((artist) => artist.key),
      topAlbums.map((album) => album.key),
    ];

    const [trackMetadata, artistMetadata, albumMetadata] = await Promise.all([
      fetchMetadata(trackIds, "tracks"),
      fetchMetadata(artistIds, "artists"),
      fetchMetadata(albumIds, "albums"),
    ]);

    // Match the metadata back to the respective topTracks, topArtists, and topAlbums based on ID
    topTracks = topTracks.map((track) => {
      const metadata = trackMetadata.find(
        (meta) => meta.id.toString() === track.key
      );
      return {
        ...track,
        // name: metadata?.name,
        ...metadata,
        image: metadata?.albums[0]?.image,
      };
    });

    topArtists = topArtists.map((artist) => {
      const metadata = artistMetadata.find(
        (meta) => meta.id.toString() === artist.key
      );
      return {
        ...artist,
        ...metadata,
        // name: metadata?.name,
        // image: metadata?.image,
      };
    });

    topAlbums = topAlbums.map((album) => {
      const metadata = albumMetadata.find(
        (meta) => meta.id.toString() === album.key
      );
      return {
        ...album,
        ...metadata,
        // name: metadata?.name,
        // image: metadata?.image,
      };
    });

    countryData = {
      labels: result.country.buckets.map((bucket) => bucket.key),
      datasets: [
        {
          data: result.country.buckets.map((bucket) =>
            convertToPercentage(bucket.doc_count)
          ),
        },
      ],
    };

    decisionData = {
      labels: result.decision.buckets.map((bucket) => bucket.key),
      datasets: [
        {
          data: result.decision.buckets.map((bucket) =>
            convertToPercentage(bucket.doc_count)
          ),
        },
      ],
    };

    subscriptionData = {
      labels: result.spotify_subscription.buckets.map((bucket) => bucket.key),
      datasets: [
        {
          data: result.spotify_subscription.buckets.map((bucket) =>
            convertToPercentage(bucket.doc_count)
          ),
        },
      ],
    };

    plusData = {
      labels: result.plus.buckets.map((bucket) => bucket.key),
      datasets: [
        {
          data: result.plus.buckets.map((bucket) =>
            convertToPercentage(bucket.doc_count)
          ),
        },
      ],
    };

    deviceData = {
      labels: result.device.buckets.map((bucket) => bucket.key),
      datasets: [
        {
          data: result.device.buckets.map((bucket) =>
            convertToPercentage(bucket.doc_count)
          ),
        },
      ],
    };

    decisionMsData = {
      ...result.decisionMs,
      percentiles: result.decisionMsPercentiles,
    };

    streamedMinutesByArtistData = result.streamedMinutesByArtist;
    totalStreamedMinutesData = result.totalStreamedMinutes;

    delete streamedMinutesByArtistData.doc_count;
    delete streamedMinutesByArtistData.stats.count;
    delete totalStreamedMinutesData.doc_count;
    delete totalStreamedMinutesData.stats.count;
    delete decisionMsData.count;

    console.log(streamedMinutesByArtistData);
    console.log(totalStreamedMinutesData);
    loading = false;
  }

  async function fetchMetadata(ids, type = "tracks") {
    const url = `https://api.stats.fm/api/v1/${type}?ids=${ids.join(",")}`;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(
        `Failed to fetch ${type} metadata: ${response.statusText}`
      );
    }
    return (await response.json()).items;
  }

  onMount(() => {
    fetchData();
  });

  async function fetchDataFromElasticsearch(query) {
    const response = await fetch(
      //   "https://cors.gemairo.app/http://prod-elastic-1.stats.fm:9200/poc_unreleased_tracks_votes/_search",
      //   "http://localhost:3000/api/v1/private/prerelease-query",
      "https://staging-api.stats.fm/api/v1/private/prerelease-query",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",

          // If your Elasticsearch has a username and password, use Authorization header
          Authorization: "FUGA123832978326723732673287328732",
        },
        body: JSON.stringify(query),
      }
    );

    if (!response.ok) {
      throw new Error(`Elasticsearch fetch error: ${response.statusText}`);
    }

    const data = await response.json();
    // console.log(data[0]);
    return data.aggregations; // Adjust based on your query structure
  }

  function downloadData() {
    // Convert the response JSON object to a string
    const jsonString = JSON.stringify(lastResponse, null, 2);
    // Create a Blob from the JSON string
    const blob = new Blob([jsonString], { type: "application/json" });
    // Generate a URL for the Blob
    const url = URL.createObjectURL(blob);
    // Create a temporary anchor element and trigger the download
    const a = document.createElement("a");
    a.href = url;
    a.download = "aggregated-data.json"; // The default file name for the download
    document.body.appendChild(a); // Append the anchor to the document
    a.click(); // Simulate a click on the anchor
    document.body.removeChild(a); // Clean up
    URL.revokeObjectURL(url); // Free up the generated URL
  }
</script>

<div class="container">
  <aside class="sidebar">
    <div class="filter-category">
      <p>
        In case you want to process yourself, download the aggregated dataset
        given your current filters here:
      </p>
      <button on:click={downloadData}>Download Data</button>
    </div>
    <br />
    <hr />
    <br />
    <h1>Filters</h1>
    <div class="filter-category">
      <div class="filter-category">
        <h3>Top</h3>
        <label>
          <input
            type="checkbox"
            bind:checked={filters.top.only}
            on:change={(e) => {
              filters.top.only = e.target.checked;
            }}
          />
          Only show Top
        </label>
        <label>
          <input
            type="checkbox"
            bind:checked={filters.top.hideVotes}
            on:change={(e) => {
              filters.top.hideVotes = e.target.checked;
            }}
          />
          Hide Votes
        </label>
      </div>
      <div class="filter-category">
        <h3>Item Limit</h3>
        <input
          style="margin-top: -50px;"
          type="range"
          min="1"
          max="1000"
          value={filters.limit}
          on:input={(e) => fetchData(e.target.value)}
        />
        <span>Showing up to {filters.limit} items</span>
      </div>

      <div class="filter-category">
        <h3>Time Range</h3>
        <!-- {#each Object.entries( { "Past 4 weeks": "WEEKS", "Past 6 months": "MONTHS", Lifetime: "LIFETIME" } ) as [label, value]}
      <label>
        <input
          type="checkbox"
          bind:group={filters.timeRange}
          {value}
          on:change={(e) => handleCheckboxChange(e, "timeRange")}
        />
        {label}
      </label>
    {/each} -->
        <select
          on:change={handleTimeRangeChange}
          bind:value={filters.timeRange}
        >
          {#each Object.entries( { "Past 4 weeks": "WEEKS", "Past 6 months": "MONTHS", Lifetime: "LIFETIME" } ) as [label, value]}
            <option {value}>{label}</option>
          {/each}
        </select>
      </div>
      <div class="filter-category">
        <h3>Decision</h3>
        {#each Object.entries( { Like: "LIKE", Dislike: "DISLIKE" } ) as [label, value]}
          <label>
            <input
              type="checkbox"
              bind:group={filters.decision}
              {value}
              on:change={(e) => handleCheckboxChange(e, "decision")}
            />
            {label}
          </label>
        {/each}
      </div>
      <div class="filter-category">
        <h3>Genre</h3>
        <select on:change={handleGenreChange} bind:value={filters.genre}>
          <option value="All Genres">All Genres</option>
          <hr />
          {#each genreSeeds as genre}
            <option value={genre}>{genre}</option>
          {/each}
        </select>
      </div>
      <div class="filter-category">
        <h3>Platform</h3>
        {#each Object.entries( { iOS: "ios", Android: "android" } ) as [label, value]}
          <label>
            <input
              type="checkbox"
              bind:group={filters.device}
              {value}
              on:change={(e) => handleCheckboxChange(e, "device")}
            />
            {label}
          </label>
        {/each}
      </div>
      <div class="filter-category">
        <h3>stats.fm subscription</h3>
        {#each Object.entries({ Free: false, Plus: true }) as [label, value]}
          <label>
            <input
              type="checkbox"
              bind:group={filters.plus}
              {value}
              on:change={(e) => handleCheckboxChange(e, "plus")}
            />
            {label}
          </label>
        {/each}
      </div>
      <div class="filter-category">
        <h3>Spotify subscription</h3>
        {#each Object.entries( { Free: "free", Open: "open", Premium: "premium" } ) as [label, value]}
          <label>
            <input
              type="checkbox"
              bind:group={filters.product}
              {value}
              on:change={(e) => handleCheckboxChange(e, "product")}
            />
            {label}
          </label>
        {/each}
      </div>
    </div>
  </aside>

  {#if loading}
    <!-- <div class="loading"> -->
    <p>Loading...</p>
    <!-- </div> -->
  {:else}
    <main>
      {#if filters.top.only === false}
        <section class="stats-section">
          <!-- Country Distribution Pie Chart -->
          <div class="stats-card">
            <h2>% of total votes</h2>
            <h1>{convertToPercentage(uniqueUserCount).toLocaleString()}</h1>
          </div>
          <div class="stats-card">
            <h2>Decision</h2>
            <Doughnut data={decisionData} />
          </div>
          <div class="stats-card">
            <h2>Decision time (ms)</h2>
            <pre style="text-align: left;">{JSON.stringify(
                decisionMsData,
                null,
                2
              )}</pre>
          </div>
          <div class="stats-card">
            <h2>Country</h2>
            <Doughnut data={countryData} />
          </div>
          <div class="stats-card">
            <h2>Spotify Subscription</h2>
            <Doughnut data={subscriptionData} />
          </div>
          <div class="stats-card">
            <h2>stats.fm Plus</h2>
            <Doughnut data={plusData} />
          </div>
          <div class="stats-card">
            <h2>Device</h2>
            <Doughnut data={deviceData} />
          </div>
        </section>
        <section class="stats-section">
          <!-- {#if streamedMinutesByArtistData.stats} -->
          <div class="stats-card">
            <h2>Chainsmokers Minutes Streamed (only Plus Users)</h2>
            <pre style="text-align: left;">{JSON.stringify(
                streamedMinutesByArtistData,
                null,
                2
              )}</pre>
            <!-- <p>
              Average: {streamedMinutesByArtistData.stats.avg} minutes
            </p>
            <p>
              95th Percentile: {totalStreamedMinutesData.percentiles.values[
                "95.0"
              ]}
              minutes
            </p> -->
          </div>
          <!-- {/if} -->

          <div class="stats-card">
            <h2>Total Minutes Streamed (only Plus Users)</h2>
            <pre style="text-align: left;">{JSON.stringify(
                totalStreamedMinutesData,
                null,
                2
              )}</pre>
            <!-- <p>Average: {totalStreamedMinutesStats.statsTotal.avg} minutes</p>
        <p>
          95th Percentile: {totalStreamedMinutesStats.percentilesTotal.values[
            "95.0"
          ]} minutes
        </p> -->
            <!-- Display other stats as needed -->
          </div>

          <!-- Other stats and visualizations go here... -->
        </section>
      {/if}

      <div class="dashboard">
        <div class="list">
          <h1>Top Tracks</h1>
          <TrackList {topTracks} hideVotes={filters.top.hideVotes} />
        </div>
        <div class="list">
          <h1>Top Artists</h1>
          <ArtistList {topArtists} hideVotes={filters.top.hideVotes} />
        </div>
        <div class="list">
          <h1>Top Albums</h1>
          <AlbumList {topAlbums} hideVotes={filters.top.hideVotes} />
        </div>
        <div class="list">
          <h1>Top Genres</h1>
          <GenreList {topGenres} hideVotes={filters.top.hideVotes} />
        </div>
      </div>
    </main>
  {/if}
</div>

<style>
  body,
  html {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  .container {
    display: flex;
    min-height: 100vh; /* Use full height of the viewport */
  }

  .sidebar {
    width: 250px; /* Adjust width as needed */
    padding: 20px;
    background-color: #f4f4f4; /* Use your app's color theme */
    border-right: 1px solid #ddd; /* Optional border */
  }

  main {
    flex-grow: 1; /* Takes the remaining space */
    padding: 16px;
  }

  .dashboard {
    display: flex;
    justify-content: space-between;
    padding: 16px;
    gap: 16px; /* Adjust the gap to your preference */
  }

  .list {
    width: 100%;
    background-color: #f8f9fa; /* Use your app's color theme */
    border-radius: 8px;
    padding: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Example shadow for card style */
  }

  .list h1 {
    font-size: 1.8rem;
    margin-bottom: 8px;
  }

  .sidebar {
    width: 200px; /* Adjust width as needed */
    padding: 20px;
    background-color: #f4f4f4; /* Use your app's color theme */
    border-right: 1px solid #ddd; /* Optional border */
  }
  .filter-category h3 {
    margin-top: 20px;
  }
  .filter-category label {
    display: block;
    margin-bottom: 5px;
  }

  .stats-section {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
    margin-bottom: 20px; /* Spacing between stats and lists */
  }

  .stats-card {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
    text-align: center; /* Center the chart title */
  }
</style>
